// mespage.js
import React, { useState, useEffect } from "react";
import { Input, Button, message, Radio, Upload, InputNumber } from "antd";
import axiosInstance from "@/axios/axiosInstance";
import "./index.scss";
const { TextArea } = Input;

const Mespage = ({ userData, fetchUserInfo, userPhoto }) => {
  const [personalIntroduce, setDec] = useState("");
  const [workYears, setWorkYears] = useState("1");
  const [sex, setSex] = useState(1);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (userData) {
      setFileList([
        {
          uid: "-1",
          name: "image.png",
          status: "done",
          url: `/file/${userData.profilePictureUrl}`,
        },
      ]);
      setDec(userData.personalIntroduce || "");
      setWorkYears(userData.workYears || "1");
      setSex(userData.sex || 1);
    }
  }, [userData]);

  const handleChange = ({ file, fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const handlePreview = (file) => {
    console.log(file.url);
  };

  const handleInputChange = (e) => {
    setDec(e.target.value);
  };

  const onChangeRadio = (e) => {
    setSex(e.target.value);
  };

  const onChangeNum = (value) => {
    setWorkYears(value);
  };

  const setUserMes = async () => {
    try {
      const formData = new FormData();
      formData.append("sex", sex);
      formData.append("workYears", workYears);
      formData.append("personalIntroduce", personalIntroduce);
      formData.append("userId", userData.userId);

      const response = await axiosInstance.post("/account/update", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.code === 10000) {
        message.success("修改成功");
        fetchUserInfo(); // 调用传递进来的 fetchUserInfo 函数
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  const customUploadRequest = (options) => {
    const formData = new FormData();
    formData.append("file", options.file);
    formData.append("userId", userData.userId);

    axiosInstance
      .post("/account/update", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.code === 10000) {
          fetchUserInfo();
          message.success("修改成功");
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });
  };

  return (
    <div className="mespage">
      <h3 className="mespage_til">个人信息</h3>
      <div className="login_mes">
        <Upload
          customRequest={customUploadRequest}
          listType="picture-card"
          fileList={fileList}
          onChange={handleChange}
          onPreview={handlePreview}
        >
          {fileList.length < 1 && "+ 上传"}
        </Upload>
      </div>
      <h5 className="mespage_til">个人介绍</h5>
      <div className="login_mes">
        <div className="login_int">
          <TextArea
            placeholder="最多输入100个字"
            showCount
            maxLength={100}
            value={personalIntroduce}
            style={{ height: 120, resize: "none", width: 300 }}
            onChange={handleInputChange}
          />
        </div>
      </div>
      <h3 className="mespage_til">个人资料</h3>
      <div className="login_mes">
        <div className="login_mes_name">当前账号名：</div>
        <div className="login_int">{userData.phone}</div>
      </div>
      <div className="login_mes">
        <div className="login_mes_name">性别：</div>
        <div className="login_int">
          <Radio.Group onChange={onChangeRadio} value={sex}>
            <Radio value={1}>男</Radio>
            <Radio value={2}>女</Radio>
          </Radio.Group>
        </div>
      </div>
      <div className="login_mes">
        <div className="login_mes_name">工作年限：</div>
        <div className="login_int">
          <InputNumber
            min={1}
            max={100}
            defaultValue={3}
            onChange={onChangeNum}
            value={workYears}
          />
        </div>
      </div>
      <Button type="primary" onClick={setUserMes}>
        保存
      </Button>
    </div>
  );
};

export default Mespage;
